/* eslint-disable react/jsx-pascal-case */
import React, { Component, forwardRef } from 'react';
import { Control, Errors } from 'react-redux-form';
import { debounce } from 'throttle-debounce';
import { Form, Button, FloatingLabel, DropdownButton } from 'react-bootstrap';
import Autosuggest from 'react-autosuggest';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import './order-request-form.component.css';
import Icons from "../../icon";
import { capitalizeFirstLetter } from '../../../utils/helpers.utils'
import { INVALID_CHARS, INPUT_FIELD_TYPE, MAX_LENGTH, INTEGER_INVALID_CHARS } from "../../../constants/external-constants"

export class ORFDropdownCheckbox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: '',
            selected: false
        };
    }

    displayOptions = (data, action, filters, id) => {

        if (data !== undefined && data !== null && data.length > 0) {
            return data.map((x, i) => {
                return (
                    <li key={'filter-' + x.Key + '-' + x.Value} data-id={JSON.stringify(x)}>
                        <input type="checkbox" id={x.Key} key={x.Key} value={x.Value} onChange={action} checked={filters.some((value) => value == x.Key)} />
                        {x.Value}
                    </li>
                );
            });
        }
    };

    render() {
        const { options, placeholder, id, selectedValues, isSelectAll, action, label } = this.props;
        return (
            <div className="orf-multiselect">

                <label className="form-control-label">{ label }</label>
                {
                    <DropdownButton
                        id={id}
                        title={selectedValues.length === 0 ? placeholder : options.filter(i => selectedValues.includes(i.Key)).map(a => a.Value).join()}
                    >
                        <label className="form-control-label" value={label}/>
                        <input type="checkbox" id={id} onChange={action} value={"Select All"} checked={isSelectAll} />
                        {"Select All"}
                        {this.displayOptions(options, action, selectedValues, id)}
                    </DropdownButton>
                    }

            </div>
        );
    }
}


export class OR_RRF_Select extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: '',
            selected: false
        };
    }

    displayOptions = data => {
        if (data !== undefined && data !== null && data.length > 0) {
            return data.map(x => {
                return (
                    <option value={x.Key} key={'option-' + x.Key + x.Value} id={x.Value}>
                        {x.Value}
                    </option>
                );
            });
        }
    };

    onChangeAction = (model, value) => {
        const { onChangeAction } = this.props;
        if (onChangeAction !== undefined && onChangeAction !== null) {
            onChangeAction(model, value);
        }
    };

    render() {
        const { options, value, fieldProp, placeholder, label, disabled, maxLength, onChangeAction, className, validators, errorMessages, valid, requiredField } = this.props;
        return (
            <div>
                <FloatingLabel controlId="floatingSelect"
                    label={
                    <>
                    {label}
                    {requiredField && <span className="mandatory_symbol"> *</span>}
                    </>
                    }
                    >
                    <Control.select
                        className={`form-select ${className == "form-control country-label" ? 'country-label' : ''}`}                         
                        value={value}
                        model={fieldProp}
                        validators={validators}
                        changeAction={onChangeAction !== undefined ? this.onChangeAction : undefined}
                        disabled={disabled}
                        maxLength={MAX_LENGTH.limit_100}
                    >
                        <option hidden>{placeholder}</option>
                        {this.displayOptions(options)}
                    </Control.select>
                </FloatingLabel>
                {
                    //<Errors
                    //    className="rrf-errors"
                    //    model={fieldProp}
                    //    show="touch"
                    //    messages={errorMessages}
                    ///>
                }
            </div>
        );
    }
}

export class ORFSelect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: '',
            selected: false
        };
    }

    displayOptions = data => {
        if (data !== undefined && data !== null && data.length > 0) {
            return data.map(x => {
                return (
                    <option value={x.Key} key={'option-' + x.Key} id={x.Value}>
                        {x.Value}
                    </option>
                );
            });
        }
    };

    render() {
        const { options, placeholder, label } = this.props;
        return (
            <Form.Group>
                <FloatingLabel controlId="floatingSelect" label={label}>
                    <Form.Select
                    >
                        <option hidden>{placeholder}</option>
                        {this.displayOptions(options)}
                    </Form.Select>
                </FloatingLabel>
            </Form.Group>
        );
    }
}

export class ORFCheckbox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: false,
        };
    }

    componentDidMount() {
        this.setState({
            value: this.props.initialValue
        });
    }

    componentDidUpdate(prevProps) {
        if(prevProps.initialValue !== this.props.initialValue) {
            this.setState({
                value: this.props.initialValue
            });
        }
        if(prevProps.resetCheckBox !==  this.props.resetCheckBox && !this.props.onTick){
            this.setState({
                value: this.props.initialValue
            });
        }
    }

    onTick = event => {
        const { action } = this.props;
        const checked = event.target.checked;
        this.setState({
            value: checked
        });

        if(this.props.checkBoxValue !==undefined)
        {
            this.props.checkBoxValue(checked)
        }

        if (action !== null && action !== undefined) {
            action(checked);
        }
    };

    setChecked = (isChecked) => {
        this.setState({
            value: isChecked
        });
    }

    render() {
        const { disable, id, label, classWrapper, maxLength } = this.props;
        return (
            <Form.Group className={`request-checkbox-container ${classWrapper}`}>
                <Form.Check
                    checked={this.state.value}
                    onChange={this.onTick}
                    disabled={disable}
                    maxLength={MAX_LENGTH.limit_100}
                >
                </Form.Check>
                <Form.Label htmlFor={id}>
                    {label}
                </Form.Label>
            </Form.Group>
        )
    }
}

export class OR_RRF_ResetButton extends Component {
    onClickAction = () => {
        const { action } = this.props;
        if (action !== null && action !== undefined) {
            this.props.action();
        }
    }

    render() {
        const { variant, hidden, disabled, label, className, model, action } = this.props;
        return (
            <Form.Group hidden={hidden}>
                <Control.reset
                    className={className}
                    model={model}
                    onClick={() => action()}
                    hidden={hidden}
                    disabled={disabled}
                >
                    {label}
                </Control.reset>
            </Form.Group>
        )
    }
}

export class ORFButton extends Component {
    onClickAction = () => {
        const { action } = this.props;
        if (action !== null && action !== undefined) {
            this.props.action();
        }
    }

    render() {
        const { variant, hidden, disabled, label, className, type } = this.props;
        return (
            <Form.Group hidden={hidden}>
                <Button
                    className={className}
                    variant={variant}
                    hidden={hidden}
                    disabled={disabled}
                    onClick={this.onClickAction.bind(this)}
                    type={type}
                >
                    {label}
                </Button>
            </Form.Group>
        )
    }
}

export class ORFField extends Component {

    render() {
        const { hidden, disable, label, size, type, placeholder, maxLength } = this.props;
        return (
            <Form.Group hidden={hidden}>
                <FloatingLabel controlId={label} label={label} hidden={hidden}>
                    <Form.Control size={size} type={type} placeholder={placeholder} disabled={disable} hidden={hidden} maxLength={MAX_LENGTH.limit_100} />
                </FloatingLabel>
            </Form.Group>
        )
    }
}

export class OR_RRF_InputField extends Component {

    onChangeAction = (model, value) => {
        const { onChangeAction } = this.props;
        if (onChangeAction !== undefined && onChangeAction !== null) {
            onChangeAction(model, value);
        }
    };
    checkValue = (e) => {
        const { type, isWithDecimal, value, maxLength } = this.props
        const Invalid_chars = isWithDecimal? INTEGER_INVALID_CHARS : INVALID_CHARS;

        if(value.length >= maxLength) e.preventDefault(); 

        if (Invalid_chars.includes(e.key) && type === INPUT_FIELD_TYPE.type ) {
            e.preventDefault();
        }
    }
    render() {
        const { hidden, disabled, label, value, fieldProp, className, type, validators, onChangeAction, placeholder } = this.props;
        return (
            <Form.Group hidden={hidden}>
                <FloatingLabel controlId={label} label={label} hidden={hidden}>
                    <Control
                        type={type}
                        className={className}
                        value={value}
                        model={fieldProp}
                        changeAction={onChangeAction !== undefined ? this.onChangeAction : undefined}
                        //validators={validators}
                        disabled={disabled}
                        onKeyPress={this.checkValue}
                        placeholder={placeholder}
                    />
                </FloatingLabel>
            </Form.Group>
        )
    }
}


export class OR_RRF_TextArea extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isClicked: false,
            value: props.value || ""
        };
        this.textareaRef = React.createRef();
    }

    handleClick = () => {
        this.setState(prevState => ({
            isClicked: !prevState.isClicked,
        }));
    };

    handleChange = (e) => {
        const { onChange } = this.props;
        this.setState({ value: e.target.value });

        if (onChange) {
            onChange(e); // Pass the change event to the parent component
        }
    }

    handleClickOutside = event => {
        if (this.textareaRef.current && !this.textareaRef.current.contains(event.target)) {
            this.setState({ isClicked: false });
        }
    };
    componentDidUpdate(prevProps) {
       
        if (this.props.value !== prevProps.value) {
            this.setState({ value: this.props.value || '' });
        }
    }
    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    render() {
        const { hidden, disabled, label, fieldProp, validators, maxLength, customClass, requiredField } = this.props;

        return (
            <Form.Group hidden={hidden}>
                <div
                    ref={this.textareaRef}
                    className={`custom-textarea ${this.state.isClicked ? "border-blue" : ""} ${disabled ? "disabled-textarea" : ""} ${customClass}`}
                    onClick={this.handleClick}
                >
                    <label htmlFor={label}>
                        {label}
                        {requiredField && <span className="mandatory_symbol"> *</span>}
                    </label>

                    <Control.textarea
                        className="form-control height-100"
                        as="textarea"
                        value={this.state.value}
                        model={fieldProp}
                        validators={validators}
                        disabled={disabled}
                        maxLength={maxLength}
                        placeholder={this.props.placeholder}
                        onChange={this.handleChange}
                    />
                </div>
            </Form.Group>
        );
    }

}

export class ORFTextArea extends Component {

    render() {
        const { hidden, disabled, label } = this.props;
        return (
            <Form.Group hidden={hidden}>
                <FloatingLabel controlId={label} label={label} hidden={hidden} className="request-textarea">
                    <Form.Control
                        disabled={disabled}
                        as="textarea"
                        className="height-100"
                        placeholder="sampel"
                    />
                </FloatingLabel>
            </Form.Group>
        )
    }
}

export class ORFSearchSuggestions extends Component {
    constructor(props) {
        super(props);

        this.state = {
              value: ""
            , suggestions: []
            , isFetching: true
            , rawOptions: []
            , withIcon: props.withIcon
            , onChangeReset: false
            , haveError: false
            , suppressNextSearch: false
        };

        this.autocompleteSearchDebounced = debounce(500, (val) => this.autocompleteSearch(val));
    }

    componentDidMount = () => {
        const { defaultValue } = this.props;
        this.setState({
            value: this.props.value
        })
        if (defaultValue) {

            this.onChange(null, { newValue: defaultValue });
            this.onChangeSuggestion(null, { newValue: defaultValue });  
        }
    }

    onChange = (event, { newValue }) => {
        this.setState({
            value: newValue
        }, () => {
            this.autocompleteSearchDebounced(this.state.value);
        });
    };

    onSuggestionsFetchRequested = ({ value }) => {
        if (value !== this.state.value) {
            this.setState({
                suggestions: this.getSuggestions(value, this.props.options)
            });
        }
    };

    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: []
        });
    };

    getSuggestions = (value, arrObj) => {
        const escapedValue = this.escapeRegexCharacters(value.trim());

        if (escapedValue === '' || !arrObj) {
            return [];
        }

        var suggestions = arrObj.map(a => a[this.props.propDisplay]);

        return suggestions?.filter(suggestion => suggestion?.toLowerCase()?.includes(value?.toLowerCase()));
    };
    //.includes(value.toLowerCase())
    escapeRegexCharacters = str => {
        return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    };

    onSuggestionSelected = (event, { suggestion, suggestionIndex }) => {
        const { propDisplay, onChangeAction, handleFirstInput } = this.props;
    
        this.setState({
            value: suggestion,
            suggestions: [],
            suppressNextSearch: true 
        });
    
        if (onChangeAction) {
            onChangeAction(suggestion, propDisplay, this.state.rawOptions, suggestionIndex);
        }
    
        if (handleFirstInput) {
            handleFirstInput();
        }
    };
    

    getSuggestionValue = suggestion => {
        this.setState({haveError: false})
        return suggestion.Name;
    };

    renderSuggestion = suggestion => {
        return <span className="orf-s-s-item">{suggestion}</span>
    };

    inputValue = (val) => {
        this.setState({value: val})
    }


    handleOnblurAction = () => {
        const { value, errorMessage } = this.props;
        const inputValue = this.state.value;

        this.inputValue(inputValue);
        if (errorMessage) {
            if (inputValue != value) {
                this.setState({ haveError: true })
                this.props?.haveError(true);
            } else {
                this.setState({ haveError: false })
                this.props?.haveError(false);
            }
        }
    }

    renderInputComponent = inputProps => {
        const { maxLength } = this.props
        var defaulSearchInput = 100
        var isMaxlength = maxLength ? maxLength : defaulSearchInput 
        const handleInputChange = e => {   
            if (e.target.value.length <= isMaxlength) {
                inputProps.onChange(e);
                this.autocompleteSearchDebounced(e.target.value);
                this.setState({ onChangeReset: true });
            }
        };

        return (
            <>
                <div className={`${this.state.withIcon ? "input-with-icon-container" : ""} ${this.state.haveError ? "has__error": ""}`}>
                    {this.state.withIcon ?
                        <div className="icon-container">
                            <Icons
                                name={"user-group"}
                                size="20px"
                                containerClass="icon-circle-plus-container"
                            />
                        </div>
                        : null}
                    <input
                        className={`react-autosuggest__input with-icon`}
                        onKeyPress={(e) => {e.key === 'Enter' && e.preventDefault();}}
                        {...inputProps}
                        onChange={handleInputChange}
                        placeholder={this.props.placeholder}
                        onBlur={this.handleOnblurAction}
                    />
                </div>
                {  this.state.haveError &&
                    <span className='warning-label'>{this.props.errorMessage}</span>
                }
                
            </>
        );
    }

    onChangeSuggestion = (event, { newValue }) => {

        this.setState({ value: newValue }, () => {
            this.autocompleteSearchDebounced(this.state.value);
        });
    };

    autocompleteSearch = (val, callback) => {
        if (this.state.suppressNextSearch) {
            this.setState({ suppressNextSearch: false });
            return;
        }
    
        if (typeof callback === 'function') {
            callback();
        }
        this._fetch(val);
    }; 

    _fetch = async val => {
        const { onChangeClear, onChangeAction, searchAction, propDisplay, defaultValue } = this.props;
        const { onChangeReset } =this.state;
        val = val.trim();

        if (val === '' && !onChangeClear ) {
            if (onChangeAction) {
                onChangeAction(val);
            }
            return;
        }
      
        if(onChangeReset) {            
            if (onChangeAction) {
                onChangeAction(val);
            }
        }

        this.setState({ isFetching: false, onChangeReset:false });
        
        var res = await searchAction(val, propDisplay);
        this.inputValue(val);
        if (res != null) {

            this.setState({
                rawOptions: res,
            });

            res = res.length > 0 ? res.map(a => a[propDisplay]) : '';
            res = res.slice(0, 10);

            this.setState({
                suggestions: res
            });

            this.setState({ isFetching: true });

            if (defaultValue == val) {
                this.onSuggestionSelected(null, { suggestion: defaultValue });
            }
        } else {
            this.setState({ isFetching: true });  
        }
    };

    render() {
        const { hidden, disabled, label, maxLength, placeholder } = this.props;
        const { value, suggestions, isFetching } = this.state;

        const inputProps = {
            placeholder: placeholder,
            value: value !== undefined ? value : '',
            onChange: this.onChangeSuggestion,
            hidden: hidden,
            disabled: disabled,
            maxLength : maxLength
        };
        return (
            <Form.Group className="orf-s-s">
                <FloatingLabel controlId={label} hidden={hidden}
                    label={
                        <>
                            {label}
                            {this.props.requiredField && <span className="mandatory_symbol"> *</span>}
                        </>
                    }
                >
                    <Autosuggest
                        //id={this.props.id}
                        suggestions={isFetching ? suggestions : []}
                        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                        onSuggestionSelected={this.onSuggestionSelected}
                        getSuggestionValue={this.getSuggestionValue}
                        renderInputComponent={this.renderInputComponent}
                        renderSuggestion={this.renderSuggestion}
                        inputProps={inputProps}
                    />
                </FloatingLabel>
            </Form.Group>
        )
    }
}

export class ORFDatePicker extends Component {

    //onClickAction = (e) => {
    //    const { action } = this.props;
    //    if (action) {
    //        this.props.action(e);
    //    }
    //}

    render() {
        const { hidden, label, className, placeholder, id, value, disabled, minDate } = this.props;
        const DatePickerText = forwardRef(({ onClick, value, disabled }, ref) => (
            <div onClick={onClick} className="icn-calendar">
                <input defaultValue={value} placeholder={placeholder} disabled={disabled} type="text" ref={ref}  />
            </div>
        ));
        return (
            <Form.Group hidden={hidden} className="orf-d-p">
                <FloatingLabel controlId={label} label={label} hidden={hidden} className="label-datepicker" />
                    <DatePicker
                        placeholder={placeholder}
                        className={'form-control ' + className}
                        popperClassName={'form-control ' + className}
                        id={id}
                        onChange={e => this.props.action(e)}
                        dateFormat="dd/MM/yyyy"
                        value={value}
                        selected={value}
                        customInput={<DatePickerText />}
                        disabled={disabled}
                        minDate={minDate}
                    />
            </Form.Group>
        )
    }
}